import { render, staticRenderFns } from "./AddToCovid19Tracker.vue?vue&type=template&id=15310218&scoped=true&"
import script from "./AddToCovid19Tracker.js?vue&type=script&lang=js&"
export * from "./AddToCovid19Tracker.js?vue&type=script&lang=js&"
import style0 from "../../Auth/AuthModal/AuthModal.scss?vue&type=style&index=0&id=15310218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15310218",
  null
  
)

export default component.exports